import Swiper from "swiper";
import { A11y, FreeMode } from "swiper/modules";
import { fireEvent } from "@/scripts/common/util";
import "./solutions.css";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".element-solutions").forEach((el) => {
    const container = el.querySelector(".swiper");
    const numSlides = container.querySelectorAll(".swiper-slide").length;

    new Swiper(container, {
      modules: [A11y, FreeMode],
      slidesPerView: "auto",
      speed: 1000,
      spaceBetween: 0,
      centerInsufficientSlides: numSlides != 2,
      centeredSlides: numSlides >= 2,
      freeMode: {
        enabled: true,
        momentumRatio: 0.8,
      },
      on: {
        touchMove: (_, event) => {
          fireEvent("swiper:drag", document.documentElement, event);
        },
        touchEnd: (_, event) => {
          fireEvent("swiper:dragend", document.documentElement, event);
        },
        init: (swiper) => {
          if (swiper.isLocked) {
            swiper.el.querySelector(".swiper-wrapper").removeAttribute("data-cursor-content");
          } else {
            swiper.el.querySelector(".swiper-wrapper").setAttribute("data-cursor-content", "Drag");
          }
        },
        resize: (swiper) => {
          if (swiper.isLocked) {
            swiper.el.querySelector(".swiper-wrapper").removeAttribute("data-cursor-content");
          } else {
            swiper.el.querySelector(".swiper-wrapper").setAttribute("data-cursor-content", "Drag");
          }
        },
      },
    });
  });
});
